import React, { useState } from "react";
import "../CSS/TabsPage.css";

import Complaints from '../Pages/Complaints.js';
import USDA from '../Pages/USDA.js';
import AALAC from '../Pages/AALAC.js';

// ✅ Import your modal component by its actual name
import EmailFormModal from '../Components/ARModal.js';

const TabsPage = () => {
  const [activeTab, setActiveTab] = useState("complaints");

  // ✅ Modal open/close state
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="tabs-page">
      <h1>AR Risk Intelligence Hub</h1>

      <div className="box">
        <p>
          Resource to observe current AR-related intelligence related to targeted entities and
          business’ operational risk – with specific attention and data toward activist-related
          targeting and reputational exposure all in one interface.
        </p>

        <p>
          We can help organizations verify the reliability and integrity of partners, vendors, and facilities.
        </p>

        <p>
          Our online services include the following available information for searching:
        </p>
      </div>

      {/* --- TAB BUTTONS --- */}
      <div className="tabs-header">
        <button
          className={activeTab === "complaints" ? "tab active" : "tab"}
          onClick={() => setActiveTab("complaints")}
        >
          Activist Complaints
        </button>

        <button
          className={activeTab === "USDA Inspection" ? "tab active" : "tab"}
          onClick={() => setActiveTab("USDA Inspection")}
        >
          USDA Inspection
        </button>

        <button
          className={activeTab === "AALAC" ? "tab active" : "tab"}
          onClick={() => setActiveTab("AALAC")}
        >
          AAALAC Accreditation
        </button>
      </div>

      {/* --- TAB CONTENT AREA --- */}
      <div className="tabs-content">
        {activeTab === "complaints" && <Complaints />}
        {activeTab === "USDA Inspection" && <USDA />}
        {activeTab === "AALAC" && <AALAC />}
      </div>

      {/* --- TEXT + MODAL TRIGGER --- */}
      <div>
        <p>
          For a full in-depth company due diligence report, to include financial information/UCCs,
          past or current lawsuits, overall media sentiments, and a full activism assessment – please
          request
          <span
            className="open-modal-link"
            onClick={() => setShowModal(true)}
            style={{ cursor: "pointer", color: "#cab069", textDecoration: "underline", marginLeft: "4px" }}
          >
            here
          </span>.
        </p>
      </div>

      {/* --- MODAL --- */}
      {showModal && (
        <EmailFormModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          orgName="Due Diligence Request"
        />
      )}
    </div>
  );
};

export default TabsPage;
